import React from 'react'

export default function WeldersOne(props) {
  return <div className='App-paper'>WeldersOne</div>
}